import React from "react";
import "./FinanceSliding.scss";

const FinanceSliding = () => {
  const logos = [
    "./assets/img/brand-image5.png",
    "./assets/img/brand-image5.png",
    "./assets/img/brand-image5.png",
    "./assets/img/brand-image5.png",
    "./assets/img/brand-image5.png",
  ];

  return (
    <div className="finance-sliding-wrapper">
      <div className="finance-sliding-flex">
        <p>----------------------------------------------------------------</p>
        <h2 className="finance-sliding-heading">1K+ BRANDS TRUST US</h2>
        <p>----------------------------------------------------------------</p>
      </div>

      <div className="finance-sliding">
        <div className="finance-sliding-track">
          {[...logos, ...logos, ...logos].map((src, index) => (
            <div className="finance-sliding-item" key={index}>
              <img src={src} alt="Logo" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FinanceSliding;
